
export const createDocumentTypeOptions = ({ intl, messages, candidateId }) => {
  return [
    {
      value: candidateId,
      label: intl.formatMessage(messages['type_candidate']),
    }
  ]
}
